// eslint-disable-next-line no-undef
const axios = require('axios').default;
const globalVars = require('../globalVars');
import { stopCrataWidget, updateCrataWidgetSession } from '@/plugins/CrataWidget';


function createAxios() {
  const instance = axios.create({
    baseURL: globalVars.apiServer,
  });
  instance.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken) {
      config.headers['Authorization'] = `Bearer ${user.accessToken}`;
    }
    return config;
  });
  instance.interceptors.response.use((response) => {
    const newAccessToken = response.headers && response.headers['picko-v2-access-token'];
    if (newAccessToken) {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      if (storedUser) {
        storedUser.accessToken = newAccessToken;
        localStorage.setItem('user', JSON.stringify(storedUser));
        updateCrataWidgetSession(newAccessToken);
      }
    }
    return Promise.resolve(response.data);
  },
  (error) => {
    if (error.response) {
      if ([401].includes(error.response.status)) {
        stopCrataWidget();
        localStorage.removeItem('user');
        // eslint-disable-next-line no-restricted-globals
        location.reload(true);
      } else if([403].includes(error.response.status)){
        location.replace('/authentication/error/error403');
      } else if([424].includes(error.response.status)){
        stopCrataWidget();
        localStorage.removeItem('user');
        // eslint-disable-next-line no-restricted-globals
        location.reload(true);
      }
      return Promise.reject(error.response.data);
    } else {
      return Promise.reject("Error al acceder a los servicios API");
    }
  });
  return instance;
}


export default createAxios;
export { createAxios };
